export default "/images/table-delete.svg?6e277c133e7cd103f79919b5981b595f";